import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const LegalCaseKeyDateEvent1 = union([
    literal("expected_exchange"),
    literal("expected_completion"),
    literal("exchange_deadline"),
    literal("completion_deadline"),
]);